<template>
	<div class="meter-water-manage-container">
		<el-card shadow="never" class="search-card">
			<div slot="header" class="card-header">
				<span>查询条件</span>
			</div>
			<div class="flex justify-start">
				<el-form :inline="true" :model="queryParams">
					<el-form-item>
						<el-input v-model="queryParams.tableNo" placeholder="请输入表编号" clearable style="width: 250px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.BeginDate" type="datetime" placeholder="选择开始时间"
							value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px" />
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="queryParams.EndDate" type="datetime" placeholder="选择结束时间"
							value-format="yyyy-MM-dd HH:mm:ss" style="width: 250px" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleSearch">查询</el-button>
						<el-button @click="handleReset">重置</el-button>
						<el-button @click="handleExport">导出</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="flex justify-start">
				<el-button @click="handleCurrentMonth">本月抄表记录</el-button>
				<el-button @click="handleLastMonth">上月抄表记录</el-button>
				<el-button @click="handleTodayList">今日抄表记录</el-button>
			</div>
		</el-card>

		<el-card shadow="never" class="table-card">
			<div slot="header" class="card-header">
				<span>消费记录</span>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column type="index" label="序号" width="50" />
				<el-table-column prop="deviceId" label="用户编号" width="120" />
				<el-table-column label="类型规格" width="90" align="center">
					<template slot-scope="{ row }">
						<el-tag>{{ getDeviceType(row.type) }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="user_name" label="用户姓名" min-width="120" />
				<el-table-column prop="tableNo" label="表编号" min-width="120" />
				<el-table-column label="当前读数" width="100" align="center">
					<template slot-scope="{ row }">
						<span style="color: #409EFF;">{{row.reading || '-'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="dosage" label="用量" min-width="120" />
				<el-table-column prop="amount" label="消费金额" min-width="120" />
				<el-table-column prop="project_code" label="项目编码" />
				<el-table-column prop="tableAddress" width="120" label="表地址" />
				<el-table-column prop="readTime" label="读表时间" min-width="160" />
			</el-table>
			<el-pagination :current-page="queryParams.pageNo" :page-size="queryParams.pageSize" :total="total"
				:page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
				@size-change="handleSizeChange" @current-change="handlePageChange" class="pagination-container" />
		</el-card>
	</div>
</template>

<script>
	import meterRequest from '@/api/meter/meterRequest';
	import { getDeviceType, formatDateTime, exportExcel, getTodayRange, getCurrentMonthRange, getLastMonthRange} from '@/api/meter/common';

	export default {
		name: 'MeterMachineReadDetail',
		data() {
			return {
				loading: false,
				list: [],
				meterList: [],
				total: 0,
				stateMap: {
					'W': '等待',
					'F': '失败',
					'C': '完成'
				},
				stateColorMap: {
					'W': 'warning',
					'F': 'danger',
					'C': 'success'
				},
				queryParams: {
					pageNo: 1,
					pageSize: 30,
					type: '1',
					tableNo: '',
					BeginDate: '',
					EndDate: ''
				}
			}
		},
		mounted() {
			this.queryParams.BeginDate = formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
			this.queryParams.EndDate = formatDateTime(new Date())
			this.meterList = JSON.parse(localStorage.getItem('METER_LIST'))
			this.fetchList()
		},
		methods: {
			getDeviceType,
			async fetchList() {
				this.loading = true
				// 构建 Map
				const meterMap = new Map(this.meterList.map(item => [item.deviceId, item]));
				// 需要拷贝的字段
				const fields = ['user_name', 'project_code', 'tableAddress'];


				try {
					const res = await meterRequest.post('/meter/readMeterDataList', this.queryParams);
					if (res.code == 200 && res.data.length > 0) {
						this.list = res.data.map(b => {
							const a = meterMap.get(b.deviceId);
							if (a) {
								const merged = {
									...b
								};
								fields.forEach(f => {
									merged[f] = a[f];
								});
								return merged;
							}
							return b; // 未匹配到则保持原样
						});
						this.total = res.totalCount || 0
					}
				} finally {
					this.loading = false
				}
			},
			handleSearch() {
				this.queryParams.pageNo = 1
				this.fetchList()
			},
			handleReset() {
				this.queryParams.tableNo = ''
				this.queryParams.BeginDate = formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000))
				this.queryParams.EndDate = formatDateTime(new Date())
				this.queryParams.pageNo = 1
				this.queryParams.pageSize = 30
				this.queryParams.type = 1
				this.fetchList()
			},
			handleSizeChange(val) {
				this.queryParams.pageSize = val
				this.fetchList()
			},
			handlePageChange(val) {
				this.queryParams.pageNo = val
				this.fetchList()
			},
			// 获取所有数据
			async handleExport() {
				// 1. 状态锁：防止连续点击
				if (this.isExporting) return;
				this.isExporting = true;

				const pageSize = 1000;
				const totalPages = Math.ceil(this.total / pageSize);
				let allData = [];
				let loadingInstance = null;

				try {
					// 2. 弹出轻量级提示框（不遮罩，2秒后自动消失）
					loadingInstance = this.$message({
						message: '正在准备导出，请稍候...',
						type: 'info',
						duration: 2000,
						showClose: false
					});

					// 3. 构建 Meter Map
					const meterMap = new Map(this.meterList.map(item => [item.deviceId, item]));
					const fields = ['user_name', 'tableType', 'project_code', 'tableAddress'];

					// 4. 循环请求数据
					for (let page = 1; page <= totalPages; page++) {
						const res = await meterRequest.post('/meter/readMeterDataList', {
							pageNo: page,
							pageSize: pageSize,
							type: 1,
							tableNo: '',
							BeginDate: formatDateTime(new Date(new Date().getTime() - 24 * 60 * 60 * 1000)),
							EndDate: formatDateTime(new Date())
						});

						if (res.code == 200) {
							const result = res.data.map(b => {
								const a = meterMap.get(b.deviceId);
								if (a) {
									const merged = {
										...b
									};
									fields.forEach(f => {
										merged[f] = a[f];
									});
									return merged;
								}
								return b;
							});
							allData = allData.concat(result);
						}

						// 5. 控制接口访问频率：请求后等待500毫秒再请求下一页
						if (page < totalPages) {
							await new Promise(resolve => setTimeout(resolve, 500));
						}
					}

					// 6. 导出数据
					this.openExport(allData);

				} catch (error) {
					console.error('导出过程中出错:', error);
					this.$message.error('导出失败，请检查网络或稍后重试');
				} finally {
					// 7. 无论成功还是失败，都要关闭 Loading 并解除锁定
					if (loadingInstance) loadingInstance.close();
					this.isExporting = false;
				}
			},
			//导出表格
			async openExport(data) {
				await exportExcel({
					fileName: '消费统计',
					sheetName: '统计',
					data: data,
					onProgress: (p) => console.log(p.stage, p.message),
				});
			},
			//获取本月抄表记录
			async handleCurrentMonth() {
				const { startTime, endTime } = await getCurrentMonthRange();
				this.queryParams.BeginDate = startTime
				this.queryParams.EndDate = endTime
				this.fetchList()
			},
			//获取上月抄表记录
			async handleLastMonth() {
				const { startTime, endTime } = await getLastMonthRange();
				this.queryParams.BeginDate = startTime
				this.queryParams.EndDate = endTime
				this.queryParams.pageNo = 1
				this.fetchList()
			},
			//获取今日抄表记录
			async handleTodayList() {
				const { startTime, endTime } = await getTodayRange();
				this.queryParams.BeginDate = startTime
				this.queryParams.EndDate = endTime
				this.queryParams.pageNo = 1
				this.fetchList()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.meter-water-manage-container {
		padding: 20px;

		.tree-container {
			min-height: 450px;
			overflow-y: auto;
			background: #fff;
			padding: 10px;
			border-radius: 4px;
		}

		.margin-top {
			margin-top: 20px;
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}

		.clearfix:after {
			clear: both;
		}
	}

	.search-card {
		margin-bottom: 16px;
	}

	.table-card {
		margin-bottom: 0;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.pagination-container {
		margin-top: 16px;
		text-align: right;
	}
</style>